
/**
 * Encodes a slug for URL
 */
export function encodeSlug(slug: string): string {
  return encodeURIComponent(slug);
}

/**
 * Decodes a slug from URL
 */
export function decodeSlug(encodedSlug: string): string {
  return decodeURIComponent(encodedSlug);
}
